import { AssistantChatMessage } from 'models/assistant';
import { maskPersonalIdentityNumbers } from 'utils/mask-personal-identity-numbers';
import { RecentError } from 'apollo/recent-errors';

const MAX_TRANSCRIPT_LENGTH = 8000;

/** Article and page links read as their titles in the ticket; the markup means nothing there. */
const withoutMarkup = (text: string): string =>
    text.replace(/\[([^\]\n]+)\]\((?:article|page):[^)\s]+\)/g, '$1').replace(/\*{1,2}([^*\n]+?)\*{1,2}/g, '$1');

const errorLine = (error: RecentError): string =>
    [
        `- ${error.at} ${error.operation}: ${error.message}`,
        error.code ? `[${error.code}]` : undefined,
        error.requestId ? `(request id ${error.requestId})` : undefined,
    ]
        .filter(Boolean)
        .join(' ');

/** DD-3780: the chat attached to a problem report, so support sees what was already tried. */
export const conversationTranscript = (
    messages: AssistantChatMessage[],
    pagePath: string,
    errors: RecentError[] = [],
): string => {
    const lines = messages.map(
        (message) => `${message.role === 'USER' ? 'User' : 'Help assistant'}: ${withoutMarkup(message.text)}`,
    );
    const errorSection = errors.length ? [`Recent errors:\n${errors.map(errorLine).join('\n')}`] : [];
    const transcript = [
        '--- Conversation with the help assistant ---',
        `Page: ${pagePath}`,
        ...errorSection,
        ...lines,
    ].join('\n\n');
    return maskPersonalIdentityNumbers(transcript).slice(0, MAX_TRANSCRIPT_LENGTH);
};
